import { render, staticRenderFns } from "./VideoAi.vue?vue&type=template&id=557fbc5d&scoped=true"
import script from "./VideoAi.vue?vue&type=script&lang=js"
export * from "./VideoAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557fbc5d",
  null
  
)

export default component.exports